// extracted by mini-css-extract-plugin
export default {"container":"NP-z","modal":"OP-z","dimensions":"PP-z","brandName":"QP-z","productName":"RP-z","recipientEmail":"SP-z","recommendedFit":"TP-z","hiddenField":"UP-z"};